import { TFunction } from 'react-i18next';
import {
  DisplayPriceParams,
  DisplayPriceResult,
  GetLocationName,
  ParamsList
} from './types';
import { PriceViewMode } from '../../GeneralAdsPage/types';
import { Cities } from '../../../utils/helpers/constants';

export const getLocationName = ({ city, location }: GetLocationName) => {
  if (!(city || location)) return;

  const isDefaultCity = city.id === Cities.Baku.id;

  if (location && isDefaultCity) return location.fullName;
  return city.name;
};

export const getParamsList = (
  { rooms, area, floor, floors }: ParamsList,
  t: TFunction
) =>
  [
    rooms && ['rooms', t('cards.item_card.rooms', { count: rooms })],
    area && ['area', `${area.value} ${area.units}`],
    floor && ['floor', `${floor}/${floors} ${t('cards.item_card.floor')}`]
  ].filter(Boolean);

export const joinTupleValues = (
  list: Array<[string, string]> | null | undefined,
  sep = ', '
): string => {
  const tuples = (list ?? []) as [string, string][];
  return tuples.map(([, v]) => v).join(sep);
};

export function getDisplayPrice({
  mode,
  price,
  leased,
  paidDaily
}: DisplayPriceParams): DisplayPriceResult {
  if (mode === PriceViewMode.PerAcre && price.perAre != null) {
    return {
      value: price.perAre,
      currency: price.currency,
      cy: 'item-card-price-per-acre',
      priceUnit: {
        text: `/${price.units ?? ''}.`,
        cy: 'item-card-price-per-acre-units'
      }
    };
  }

  let rentSuffix;
  if (leased && paidDaily !== null) {
    rentSuffix = {
      type: paidDaily ? 'per_day' : 'per_month',
      cy: 'item-card-price-container'
    };
  }

  return {
    value: price?.full?.toLocaleString('ru-RU'),
    currency: price?.currency,
    cy: 'item-card-price-full',
    rentSuffix
  };
}
